import { FeatureFlagKey } from "../featureFlags/keys.js";
const isPerformanceCompany = (company) => company.billing_current_plan === "performance-1";
const performancePlanDefaultFeatureFlagKeys = [
  FeatureFlagKey.TeamPerformanceTab,
  FeatureFlagKey.AgentsTab,
  FeatureFlagKey.Training,
  FeatureFlagKey.HideHireTab
];
const planOrder = [
  "starter-1",
  "growth-1",
  "scale-1",
  "fountain-1",
  "performance-1"
];
const BillingPlansEnumToDisplayName = {
  "starter-1": "Starter",
  "growth-1": "Growth",
  "scale-1": "Scale",
  "fountain-1": "Fountain",
  "performance-1": "Performance"
};
const PLAN_FEATURE_ACCESS = {
  "starter-1": {
    salesforce_integration: false,
    project_level_context: false,
    whitelabeling: false
  },
  "growth-1": {
    salesforce_integration: true,
    project_level_context: true,
    whitelabeling: true
  },
  "scale-1": {
    salesforce_integration: true,
    project_level_context: true,
    whitelabeling: true
  },
  "fountain-1": {
    salesforce_integration: false,
    project_level_context: true,
    whitelabeling: true
  },
  "performance-1": {
    salesforce_integration: false,
    project_level_context: false,
    whitelabeling: false
  }
};
const companyIsInTrial = (company) => company.trial_expires_at && new Date(company.trial_expires_at) > /* @__PURE__ */ new Date();
const getCompanyHasFeatureAccess = (company, featureName) => {
  if (companyIsInTrial(company)) return true;
  if (!company.billing_current_plan) return false;
  return PLAN_FEATURE_ACCESS[company.billing_current_plan][featureName];
};
const getCompanyHasBrandingAccess = (company) => getCompanyHasFeatureAccess(company, "whitelabeling") || isPerformanceCompany(company);
const getLowestPlanNameWithFeatureAccess = (featureName) => {
  for (const plan of planOrder) {
    const features = PLAN_FEATURE_ACCESS[plan];
    if (features[featureName]) {
      return BillingPlansEnumToDisplayName[plan];
    }
  }
  throw new Error("Feature not available on any plan");
};
export {
  BillingPlansEnumToDisplayName,
  PLAN_FEATURE_ACCESS,
  companyIsInTrial,
  getCompanyHasBrandingAccess,
  getCompanyHasFeatureAccess,
  getLowestPlanNameWithFeatureAccess,
  isPerformanceCompany,
  performancePlanDefaultFeatureFlagKeys
};
//# sourceMappingURL=billingFeatureGating.js.map
